module.exports = __webpack_public_path__ + "img/productComparision1.13d779b0.png";